var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-detail"},[_c('div',{staticClass:"product-detail__img mb-12 container"},[_c('v-img',{staticClass:"ma-auto mb-8",attrs:{"src":_vm.product.imgBig,"max-width":"500","max-height":"500"}})],1),_c(_vm.product.name,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }